import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import YoutubePlayer from 'youtube-player';

import Image from './Image';
import PlayIcon from './icons/Play';

import * as styles from './Video.module.css';

const Video = ({ preview, videoId, caption = '' }) => {
  const [playing, setPlaying] = useState(false);

  const player = useRef();
  useEffect(() => {
    if (videoId) {
      player.current = YoutubePlayer(videoId, {
        videoId: videoId,
        playerVars: {
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
          fs: 1,
          origin: window.location.origin
        }
      });
      let timer;
      const reset = e => {
        if (e.data === 0) {
          // end of video
          setPlaying(false);
        } else if (e.data === 2) {
          // manually stopped video
          timer = setTimeout(() => setPlaying(false), 5000);
        }
      };
      player.current.on('stateChange', reset);
      return () => {
        clearTimeout(timer);
        player.current.destroy();
      };
    }
  }, [videoId]);

  const play = p => {
    if (!videoId) return;

    setPlaying(p);
    p ? player.current.playVideo() : player.current.stopVideo();
  };

  return (
    <div
      className={cn(styles.root, { [styles.playing]: playing })}
      style={{
        '--video-ratio': `${preview.width} / ${preview.height}`
      }}
    >
      <Image image={preview} className={cn(styles.previewImage)} />
      <div className={styles.player} id={videoId} />

      <button
        aria-label={caption}
        className={cn(styles.play)}
        onClick={() => play(true)}
        onTouchEnd={() => play(true)}
      >
        <PlayIcon className={cn(styles.playIcon)} />
      </button>
    </div>
  );
};

export default Video;
